var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H3C1.3425 0 0 1.3425 0 3V24C0 25.6575 1.3425 27 3 27H24C25.6575 27 27 25.6575 27 24V3C27 1.3425 25.6575 0 24 0ZM9 21H5.2155V10.5H9V21ZM7.041 8.5755C5.8845 8.5755 5.112 7.8045 5.112 6.7755C5.112 5.7465 5.883 4.9755 7.1685 4.9755C8.325 4.9755 9.0975 5.7465 9.0975 6.7755C9.0975 7.8045 8.3265 8.5755 7.041 8.5755ZM22.5 21H18.837V15.261C18.837 13.674 17.8605 13.308 17.4945 13.308C17.1285 13.308 15.9075 13.5525 15.9075 15.261C15.9075 15.5055 15.9075 21 15.9075 21H12.123V10.5H15.9075V11.9655C16.395 11.1105 17.3715 10.5 19.203 10.5C21.0345 10.5 22.5 11.9655 22.5 15.261V21Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1979af35c82b5b9afee71f60b37d422c.svg";
export { ForwardRef as ReactComponent };